.domain {
    font-weight: 500;
}
